import { render, staticRenderFns } from "./ListaVerificacionPunto.vue?vue&type=template&id=21204665&scoped=true"
import script from "./ListaVerificacionPunto.vue?vue&type=script&lang=js"
export * from "./ListaVerificacionPunto.vue?vue&type=script&lang=js"
import style0 from "./ListaVerificacionPunto.vue?vue&type=style&index=0&id=21204665&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21204665",
  null
  
)

export default component.exports